<template>
  <div class="season-register join-form">
    <ul class="input-div">
      <li class="title">실사용자 이름</li>
      <li>
        <input type="text" class="input-style" v-model="formData.name" placeholder="실사용자 이름을 입력하세요">
      </li>
    </ul>
    <ul class="input-div">
      <li class="title">시즌권 번호</li>
      <li class="li-flex">
        <div class="input width">
          <input type="text" class="input-style" v-model="formData.number" placeholder="시즌권 번호를 입력하세요">
        </div>
        <div class="radio pr-20">
          <input type="radio" name="userAgree" v-model="formData.numUser" value="me" class="select-style" checked="checked">
          <label class="radio-label pr">실사용자(본인)</label>
          <input type="radio" name="userAgree" v-model="formData.numUser" value="children" class="select-style">
          <label class="radio-label">실사용자(자녀)</label>
        </div>
      </li>
    </ul>
    <ul class="input-div">
      <li class="title">실사용자 휴대폰번호</li>
      <li class="phone-li">
        <div class="input">
          <InputPhone v-model="formData.phone1" :value="formData.phone1" :dash-check="false" :maxLen="3" class="width-component" />
          <span>-</span>
          <InputPhone v-model="formData.phone2" :value="formData.phone2" :dash-check="false" :maxLen="4" class="width-component" />
          <span>-</span>
          <InputPhone v-model="formData.phone3" :value="formData.phone3" :dash-check="false" :maxLen="4" class="width-component" />
        </div>
        <div class="radio pr-45">
          <input type="radio" name="msgAgree" v-model="formData.msgPush" :value="true" class="select-style" checked="checked">
          <label class="radio-label pr">메시지 수신</label>
          <input type="radio" name="msgAgree" v-model="formData.msgPush" :value="false" class="select-style">
          <label class="radio-label">메시지 미수신</label>
        </div>
      </li>
    </ul>
    <ul class="input-div">
      <li class="title">실사용자 이메일 주소 입력</li>
      <li class="li-flex">
        <div class="input width">
          <input type="text" class="input-style" v-model="formData.email" placeholder="이메일 주소를 입력하세요">
        </div>
        <div class="radio pr-45">
          <input type="radio" name="emailAgree" v-model="formData.emailPush" :value="true" class="select-style" checked="checked">
          <label class="radio-label pr">이메일 수신</label>
          <input type="radio" name="emailAgree" v-model="formData.emailPush" :value="false" class="select-style">
          <label class="radio-label">이메일 미수신</label>
        </div>
      </li>
    </ul>
    <ul class="input-div">
      <li class="title">주소입력</li>
      <li class="add-flex addr-cont">
        <input type="text" class="input-style" v-model="formData.addrNum" placeholder="우편번호" @click="searchAddress" readonly>
        <button class="id-check" @click="searchAddress">우편번호 검색</button>
        <div class="zipcodeWrap" ref="embed"></div>
      </li>
      <li class="mt-12">
        <input type="text" class="input-style" v-model="formData.address1" placeholder="주소를 입력하세요" readonly>
      </li>
      <li class="mt-12">
        <input type="text" class="input-style" v-model="formData.address2" placeholder="상세 주소를 입력하세요">
      </li>
    </ul>
    <ul class="input-div">
      <li class="title">개인정보 수집 및 이용에 대한 안내(필수)</li>
      <li>
        <div class="text-area">
<pre>
정보통신망법 규정에 따라 전남드래곤즈 홈페이지에 회원가입 신청하시는 분께 수집하는 개인정보의 항목, 개인정보의 수집 및 이용목적, 개인정보의 보유 및 이용기간을 안내 드리오니 자세히 읽은 후 동의하여 주시기 바랍니다.


□ 개인정보의 수집 및 이용 동의
㈜전남드래곤즈는 귀하께서 전남드래곤즈 홈페이지(www.dragons.co.kr)의 이용약관의 내용에 대해 「동의한다」 버튼 또는 「동의하지 않는다」 버튼을 클릭할 수 있는 절차를 마련하여, 「동의한다」 버튼을 클릭하면 개인정보 수집에 대해 동의한 것으로 간주합니다.


전남드래곤즈 홈페이지는 회원가입 시 서비스 이용을 위해 필요한 최소한의 개인정보만을 수집합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보 보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행 할 예정입니다.


회원가입 시점에 전남드래곤즈가 이용자로부터 수집하는 개인정보는 아래와 같습니다.
- 회원 가입 시에 ‘이름, 아이디, 비밀번호, 핸드폰번호, 이메일주소, 회원인증을 통한 생년월일, 성별, 암호화된 이용자 확인값(CI), 중복가입확인정보(DI)’를 필수항목으로 수집합니다.


개인정보 항목별 구체적인 수집목적 및 이용목적은 다음과 같습니다.
- 이름, 아이디, 비밀번호, 생년월일, 성별, 암호화된 이용자 확인값(CI), 중복가입확인정보(DI) : 회원제 서비스 이용에 따른 본인 식별 절차에 이용

- 이메일주소, 핸드폰번호 : 공지사항 전달, 개인맞춤 서비스, 경품 배송 등을 위한 원활한 의사소통 경로의 확보 등의 안내


□ 수집하는 개인정보 항목
① 필수 개인정보 항목 : 이름, 아이디, 비밀번호, 핸드폰번호, 이메일주소, 회원인증을 통한 생년월일, 성별, 암호화된 이용자 확인값(CI), 중복가입확인정보(DI)

② 선택 개인정보 항목 : 없음


□ 개인정보의 보유기간 및 이용기간
전남드래곤즈 홈페이지는 수집된 개인정의 보유기간은 회원가입 하신후 회원탈퇴 시 지체없이 파기됩니다. 또한 해지시 전남드래곤즈 홈페이지는 회원님의 개인정보를 재생이 불가능한 방법으로 즉시 파기합니다(개인정보가 제3자에게 제공된 경우에는 제3자에게도 파기하도록 지시합니다.). 다만, 다음 각호의 경우에는 각 호에 명시한 기간동안 개인정보를 보유합니다.


① 상법 등 법령의 규정에 의하여 보존할 필요성이 있는 경우에는 법령에서 규정한 보존기간 동안 거래내역과 최소한의 기본정보를 보유함

② 보유기간을 회원님에게 미리 고지하고 그 보유기간이 경과하지 아니한 경우와 개별적으로 회원님의 동의를 받을 경우에는 약속한 보유기간 동안 보유함


□ 동의 거부 권리 및 동의 거부 시 불이익 내용
전남드래곤즈 홈페이지 이용을 위해 필요한 최소한의 개인정보이므로 동의를 해 주셔야 서비스 이용이 가능합니다. 귀하는 개인정보의 수집목적 및 이용목적에 대한 동의를 거부할 수 있으며, 동의 거부시 전남드래곤즈 홈페이지에 회원가입이 되지 않으며, 전남드래곤즈 홈페이지에서 제공하는 제한적인 서비스(쇼핑몰, 원정버스, 시즌권등록)를 이용할 수 없습니다.


</pre>
        </div>
      </li>
      <li class="info-agree">
        <input type="radio" name="privacyPush" v-model="formData.privacyPush" :value="true" class="select-style">
        <label class="radio-label pr">동의</label>
        <input type="radio" name="privacyPush" v-model="formData.privacyPush" :value="false" class="select-style" checked="checked">
        <label class="radio-label">미동의</label>
      </li>
    </ul>
    <ul class="input-div">
      <li class="title">광고성 정보 수신 동의 안내(선택)</li>
      <li>
        <div class="text-area">
<pre>
회사는 다음과 같이 귀하의 개인정보를 수집 및 이용 합니다.

1. 개인정보의 수집 및 이용 목적
- 구단 소식 및 경기 정보 안내, 이벤트, 홍보, 프로모션 정보 등 전자적 전송매체를 이용한 광고성 정보 전송

2. 수집하는 개인정보의 항목
- 아이디, 회원명, 핸드폰번호

3. 개인정보의 보유 및 이용기간
- 수신 거부 혹은 회원 탈퇴시까지

4. 동의를 거부할 권 리 및 동의 거부시 불이익 사항
귀하는 본 개인정보의 수집 및 이용에 대한 동의를 거부할 권리가 있으며, 동의를 거부하더라도 별도의 불이익 사항은 없습니다.
</pre>
        </div>
      </li>
      <li class="info-agree">
        <input type="radio" name="adPush" v-model="formData.adPush" :value="true" class="select-style">
        <label class="radio-label pr">동의</label>
        <input type="radio" name="adPush" v-model="formData.adPush" :value="false" class="select-style" checked="checked">
        <label class="radio-label">미동의</label>
      </li>
    </ul>
    <div class="btn-div">
      <button class="login-btn" @click="ticketRegister">시즌권 등록</button>
    </div>
  </div>
</template>

<script>
import InputPhone from '@/components/Common/InputPhone.vue';
import {isEmail, isEmpty, onlyNumber, trim, allTrim} from '@/lib';

export default {
  name: 'TicketSeasonRegister',
  components: {InputPhone},
  data() {
    return {
      formData: {
        name: '',
        numUser: 'me',
        phone1: '',
        phone2: '',
        phone3: '',
        msgPush: true,
        email: '',
        emailPush: true,
        addrNum: '',
        address1: '',
        address2: '',
        privacyPush: null,
        adPush: null
      },
    }
  },
  mounted () {
  },
  methods: {
    searchAddress() {
      new window.kakao.Postcode({
        oncomplete: (data) => {
          this.formData.addrNum = data.zonecode;
          this.formData.address1 = data.address;
        }
      }).embed(this.$refs.embed);
    },
    validityCheck() {
      if(isEmpty(trim(this.formData.name))) {
        alert('실사용자 이름을 입력하세요.');
        return false;
      }
      if(isEmpty(allTrim(this.formData.number))) {
        alert('시즌권 번호를 입력하세요.');
        return false;
      }
      if(isEmpty(allTrim(this.formData.phone1))&&isEmpty(allTrim(this.formData.phone2))&&isEmpty(allTrim(this.formData.phone3))) {
        alert('실사용자 휴대폰번호를 입력하세요.');
        return false;
      }
      if(isEmpty(allTrim(this.formData.email))) {
        alert('실사용자 이메일 주소를 입력하세요.');
        return false;
      }
      if(!isEmail(this.formData.email)) {
        alert('형식에 맞게 이메일 주소를 입력하세요.');
        return false;
      }
      if(isEmpty(allTrim(this.formData.addrNum))) {
        alert('우편번호를 검색하세요.');
        return false;
      }
      if(isEmpty(trim(this.formData.address2))) {
        alert('상세 주소를 입력 하세요.');
        return false;
      }
      if(isEmpty(this.formData.privacyPush)) {
        alert('개인정보 수집 및 이용에 대한 안내에 동의해주세요.');
        return false;
      }
      if(!this.formData.privacyPush) {
        alert('개인정보 수집 및 이용 동의가 필요합니다. 동의하지 않으면 이용이 제한됩니다.');
        return false;
      }
      if(isEmpty(this.formData.adPush)) {
        alert('광고성 정보 수신 동의 안내를 선택해주세요.');
        return false;
      }

      return true;
    },
    async ticketRegister() {
      if(!this.validityCheck()) {
        return false;
      }

      if(confirm('등록 하시겠습니까?')) {
        const formData = {
          name: trim(this.formData.name),
          number: allTrim(this.formData.number),
          type: this.formData.numUser,
          mobileno: allTrim(this.formData.phone1) + allTrim(this.formData.phone2) + allTrim(this.formData.phone3),
          sms: this.formData.msgPush ? 'Y' : 'N',
          email: allTrim(this.formData.email),
          ems: this.formData.emailPush ? 'Y' : 'N',
          zipcode: allTrim(this.formData.addrNum),
          address1: trim(this.formData.address1),
          address2: trim(this.formData.address2),
          agree_sms: this.formData.privacyPush ? 'Y' : 'N'
        }

        const {data} = await this.$http.post('/ticket/season', formData);
        if(data.success) {
          alert('시즌권 등록이 완료되었습니다.');
          await this.$router.push({name: 'seasonList'});
        } else {
          if(data.message) {
            alert(data.message);
          } else {
            alert('시즌권 등록에 실패하였습니다.');
          }
        }

        // 초기화
        this.formData = {
          name: '',
          numUser: 'me',
          phone1: '',
          phone2: '',
          phone3: '',
          msgPush: true,
          email: '',
          emailPush: true,
          addrNum: '',
          address1: '',
          address2: '',
          privacyPush: true,
          adPush: true
        };
        window.scrollTo({top: 0, behavior: 'smooth'});
      }
    },
    numCheck() {
      return onlyNumber(this.formData.number);
    },
  }
}
</script>
